import {get} from "../util/http.service";

export const verifyEmail = email => get("/emails/validity", {email});
